import { find, get } from 'lodash';
import { includesServiceType } from 'common/utils/ServiceTypes';

export default function isValidServiceType({
  values,
  groupProgram, serviceType, user,
}) {
  let serviceTypes = get(groupProgram, 'service_types', []);

  if (get(groupProgram, 'is_default')) {
    // CORE-WORK - Need to resolve network.service_types
    const network = values?.network;
    const networkId = network?.id;
    const selectedNetwork = find(user.networks, { id: networkId }) || {};
    serviceTypes = selectedNetwork.service_types || [];
  }

  return includesServiceType(serviceType, serviceTypes);
}
